import { VictoryLabel, VictoryLabelProps, VictoryPortal } from 'victory';

interface CustomLabelProps {
  isLegacy: boolean;
}

export const CustomLabel: React.FC<CustomLabelProps> = ({ isLegacy, ...props }) => {
  const gridProps = props as VictoryLabelProps;
  if (isLegacy)
    return (
      <VictoryPortal>
        <VictoryLabel {...gridProps} y={15} x={29} />
      </VictoryPortal>
    );
  return null;
};
